import { ListChecks, ScanSearch, TriangleRight, HardHat, Zap, type LucideIcon } from "lucide-react";
import { MODULE_PRESENTATION, isAssessmentModuleCode } from "@taskiq/shared";
import { IconTile } from "@/components/ui/IconTile";

const BY_NAME: Record<string, LucideIcon> = {
  "scan-search": ScanSearch,
  "triangle-right": TriangleRight,
  "hard-hat": HardHat,
  zap: Zap,
};

const FALLBACK: LucideIcon = ListChecks;

/** The module's bare glyph, for a place that brings its own frame - a nav row. */
export function moduleGlyph(code: string | undefined): LucideIcon {
  const name = code && isAssessmentModuleCode(code) ? MODULE_PRESENTATION[code].icon : undefined;
  return (name ? BY_NAME[name] : undefined) ?? FALLBACK;
}

/** The tone of the tile, mirroring `ModuleRow` on the phone. */
export type ModuleIconTone = "neutral" | "ok";

export function ModuleIcon({
  code,
  tone = "neutral",
}: {
  code: string | undefined;
  tone?: ModuleIconTone;
}) {
  const Glyph = moduleGlyph(code);

  return (
    <IconTile tone={tone} size="md">
      <Glyph aria-hidden />
    </IconTile>
  );
}
